import { jsxs as u, jsx as o } from "react/jsx-runtime";
import { useState as d, useRef as N, useEffect as U } from "react";
import e from "./header.module.less.js";
import { SlideInMenu as V } from "./components/slide-in-menu/slide-in-menu.js";
import $ from "./components/language-selection/language-selection.js";
import { m as q } from "motion/react";
import { useAnimateFadeIn as z } from "../../../animation/animation.js";
import { clearAllBodyScrollLocks as G, enableBodyScroll as w, disableBodyScroll as M } from "body-scroll-lock";
import { isMobileDevice as J } from "../../../helpers/device-helper.js";
import "dayjs";
import { Search as K } from "../../elements/search-components/search/search.js";
import { HeaderButton as R } from "./components/header-button/header-button.js";
import { useDebounce as X } from "../../../hooks/useDebounce.js";
import { useTranslation as Y } from "react-i18next";
import { useSearchQuery as Z } from "../../../react-query-queries/use-search-query.js";
import { shouldShowSearchLoader as ee } from "../../../helpers/search-helper.js";
import oe from "../../elements/link-wrapper/link-wrapper.js";
const Le = ({
  logo: v,
  popularLinks: y,
  menuItems: I,
  popularLinksHeading: O,
  siblingSiteInformation: b,
  languages: f,
  currentLanguage: l,
  currentPageUrl: B,
  siteId: k,
  recommendedSearchLinks: T,
  masterLanguage: W,
  hideSearch: _ = !1,
  onSearchChange: n
}) => {
  const [c, h] = d(!1), [i, S] = d(!1), [t, j] = d(""), D = z({ whileInView: !0, easing: "easeInOut" }), r = N(null), s = N(null), a = !J(), { t: A } = Y(), E = X(t), {
    data: H,
    isLoading: g,
    error: x
  } = Z(E, l, k), F = ee(g, t, E);
  U(() => () => {
    a && G();
  }, []);
  const P = () => {
    S(!0), typeof n == "function" && n(t, !0), s && s.current && a && M(s.current);
  }, m = () => {
    S(!1), typeof n == "function" && n(t, !1), s && s.current && a && w(s.current);
  }, C = () => {
    i && m(), h(!0), r && r.current && a && M(r.current);
  }, p = () => {
    h(!1), r && r.current && a && w(r.current);
  }, Q = (L) => {
    typeof n == "function" && n(L, i), j(L);
  };
  return /* @__PURE__ */ u("header", { id: "languageSelectionPortalWrapper", className: e.wrapper, children: [
    /* @__PURE__ */ o("div", { className: [e.topBar, c ? e.menuOpen : ""].join(" "), children: /* @__PURE__ */ u(q.div, { ...D, className: [e.innerWrapper, "max-width padded-sides"].join(" "), children: [
      /* @__PURE__ */ o(oe, { url: l === "sv" ? "/" : `/${l}`, children: /* @__PURE__ */ o("div", { className: e.logoWrapper, children: /* @__PURE__ */ o("img", { className: e.logo, src: v, alt: "Preem Logo" }) }) }),
      /* @__PURE__ */ u("div", { className: e.languageSelectionOpenMenuWrapper, children: [
        /* @__PURE__ */ o(
          $,
          {
            className: e.languageSelection,
            currentLanguage: l,
            languages: f,
            hideMobile: !0
          }
        ),
        !_ && /* @__PURE__ */ o(
          R,
          {
            ariaLabel: A("HEADER_SEARCH_ARIA_LABEL"),
            isActive: i,
            icon: i ? "ui-icon-close" : "ui-icon-search",
            onClick: i ? m : P
          }
        ),
        /* @__PURE__ */ o(
          R,
          {
            ariaLabel: A("HEADER_MENU_ARIA_LABEL"),
            className: e.menuButton,
            noSeparator: !0,
            icon: c ? "ui-icon-close" : "ui-icon-menu",
            onClick: c ? p : C
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ o(
      K,
      {
        wrapperClassName: e.searchWrapper,
        isOpen: i,
        isLoadingSearchResults: F,
        results: H,
        searchTerm: t,
        hasError: !!x,
        scrollAllowedRef: s,
        recommendedLinks: T,
        onChangeSearchTerm: Q,
        closeSearchFunc: m
      }
    ),
    /* @__PURE__ */ o(
      V,
      {
        isOpen: c,
        scrollAllowedRef: r,
        currentPageUrl: B,
        currentLanguage: l,
        languages: f,
        menuItems: I,
        closeMenuFunc: p,
        popularLinks: y,
        popularLinksHeading: O,
        siblingSiteInformation: b,
        masterLanguage: W
      }
    ),
    /* @__PURE__ */ o("div", { className: [e.overlay, c ? e.open : ""].join(" "), onClick: p })
  ] });
};
export {
  Le as Header,
  Le as default
};
